import { render, staticRenderFns } from "./FeedbackRemovalToolModal.vue?vue&type=template&id=af63c4de&scoped=true&"
import script from "./FeedbackRemovalToolModal.vue?vue&type=script&lang=js&"
export * from "./FeedbackRemovalToolModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af63c4de",
  null
  
)

export default component.exports